import { render, staticRenderFns } from "./ExpendManage.vue?vue&type=template&id=ca183c96&scoped=true&"
import script from "./ExpendManage.vue?vue&type=script&lang=js&"
export * from "./ExpendManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca183c96",
  null
  
)

export default component.exports